import React from 'react';
import { Grid, Row, Col, Button, Typography } from '@sm/wds-react';
import { TabletScreen, DesktopScreen, MobileScreen } from '@sm/webassets';
import { T } from '@sm/intl';

import { getLinkGenerator } from '../../helpers/logging';
import expertsImage from './experts.png';
import './here-to-help.scss';

export const COPY = {
  title: {
    id: 'mrx.HereToHelp.title',
    defaultMessage: 'Expert help for your market research program',
    description:
      '[Type: Header][Vis: med] - Title of a section of the market research experience page where we explain our customer support',
  },
  description1: {
    id: 'mrx.HereToHelp.description1',
    defaultMessage:
      'Looking for an online panel to pinpoint hard-to-reach groups? Need to get a market research survey translated into Spanish? ' +
      'Want reassurance that your survey logic is set up correctly? We have you covered with support and services that scale to meet your needs.',
    description: '[Type: Paragraph][Vis: med] - Description of our market research customer support',
  },
  description2: {
    id: 'mrx.HereToHelp.description2',
    defaultMessage: 'Choose from bundled or pay-as-you-go market research services.',
    description: '[Type: Paragraph][Vis: med] - Description of our market research customer support',
  },
  learnMore: {
    id: 'mrx.HereToHelp.learnMore',
    defaultMessage: 'Learn more',
    description: '[Type: Link][Vis: med] - Link to learn more about our market research solutions',
  },
};

export const TEST_ID = 'HereToHelp';

const getLink = getLinkGenerator({
  ut_source: 'market_research',
  ut_source2: 'solutions',
  ut_source3: 'sm-button',
});

const getBodySection = isMobile => (
  <Col className="sm-here-to-help__body">
    <div className="sm-here-to-help__body-wrapper">
      <Typography className="sm-here-to-help__body-title" component="h2">
        <T desc={COPY.title} />
      </Typography>
      <Typography className="sm-here-to-help__body-text" component="p">
        <T desc={COPY.description1} />
      </Typography>
      <Typography className="sm-here-to-help__body-text" component="p">
        <T desc={COPY.description2} />
      </Typography>
      <Button
        href={getLink('/market-research/services', {
          ut_ctatext: 'Learn more',
        })}
        className="sm-here-to-help__body-cta"
        size={isMobile ? 'lg' : undefined}
      >
        <T desc={COPY.learnMore} />
      </Button>
    </div>
  </Col>
);

const HereToHelp = () => (
  <Grid noBleeds noGutters fluid className="sm-here-to-help" data-testid={TEST_ID}>
    <TabletScreen>
      <Row>
        <Col className="wds-flex">
          <img className="sm-here-to-help__image" src={expertsImage} aria-hidden alt="" />
        </Col>
        {getBodySection(false)}
        <DesktopScreen>
          <Col lg={1} xl={2} />
        </DesktopScreen>
      </Row>
    </TabletScreen>
    <MobileScreen>
      <Row>{getBodySection(true)}</Row>
      <Row>
        <Col className="wds-flex">
          <img className="sm-here-to-help__image" src={expertsImage} aria-hidden alt="" />
        </Col>
      </Row>
    </MobileScreen>
  </Grid>
);

export default HereToHelp;
